module.exports = __webpack_public_path__ + "1f744f28a1049d9b8efeeaef38305d20.png";